// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo__13VgX","authButton":"header_authButton__1GMdS"};